import { ShieldTick } from "iconsax-react";
import styled from "styled-components";

export const Container = styled.section`
  display: flex;
  flex-direction: column;

  width: 100%;
  margin: 2rem 0 0;
`;

export const ShieldIcon = styled(ShieldTick)`
  min-width: 1.25rem;
  min-height: 1.25rem;
  margin: 0 0.5rem 0 0;

  font-size: 1.25rem;
  color: ${({ theme }) => theme.checkoutStepsOffers?.placeholderColor};
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
`;

export const Title = styled.h4`
  margin: 0;

  font-family: Inter;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.5rem;
  text-align: center;

  color: ${({ theme }) => theme.checkoutStepsOffers?.placeholderColor};
`;

export const Strong = styled.strong`
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 700;
  line-height: 1.25rem;

  color: ${({ theme }) => theme.checkoutStepsOffers?.widgetTextColor};
`;

export const Paragraph = styled.p`
  font-family: Inter;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-align: center;

  color: ${({ theme }) => theme.checkoutStepsOffers?.placeholderColor};

  &:last-child {
    margin: 1rem 0 0;
  }
`;

export const ParagraphAlertInterest = styled.p`
  font-family: Inter;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.25rem;
  text-align: center;

  color: ${({ theme }) => theme.checkoutStepsOffers?.placeholderColor};
`;
